import { render, staticRenderFns } from "./countdown.vue?vue&type=template&id=3cf05835&scoped=true&"
import script from "./countdown.vue?vue&type=script&lang=js&"
export * from "./countdown.vue?vue&type=script&lang=js&"
import style0 from "./countdown.vue?vue&type=style&index=0&id=3cf05835&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf05835",
  null
  
)

export default component.exports